(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('stream'), require('http'), require('url'), require('https'), require('zlib'), require('date-fns'), require('date-fns/locale')) :
  typeof define === 'function' && define.amd ? define(['exports', 'stream', 'http', 'url', 'https', 'zlib', 'date-fns', 'date-fns/locale'], factory) :
  (global = global || self, factory(global['fbk-utils'] = {}, global.Stream, global.http, global.Url, global.https, global.zlib, global.dateFns, global.locale));
}(this, (function (exports, Stream, http, Url, https, zlib, dateFns, locale) { 'use strict';

  Stream = Stream && Object.prototype.hasOwnProperty.call(Stream, 'default') ? Stream['default'] : Stream;
  http = http && Object.prototype.hasOwnProperty.call(http, 'default') ? http['default'] : http;
  Url = Url && Object.prototype.hasOwnProperty.call(Url, 'default') ? Url['default'] : Url;
  https = https && Object.prototype.hasOwnProperty.call(https, 'default') ? https['default'] : https;
  zlib = zlib && Object.prototype.hasOwnProperty.call(zlib, 'default') ? zlib['default'] : zlib;

  function chunkify(array, chunkSize) {
      var chunks = Array.from({ length: Math.ceil(array.length / chunkSize) }, function (_, i) {
          var start = chunkSize * i;
          return array.slice(start, start + chunkSize);
      });
      return chunks;
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  function getCjsExportFromNamespace (n) {
  	return n && n['default'] || n;
  }

  var mailcheck = createCommonjsModule(function (module) {
  /*
   * Mailcheck https://github.com/mailcheck/mailcheck
   * Author
   * Derrick Ko (@derrickko)
   *
   * Released under the MIT License.
   *
   * v 1.1.1
   */

  var Mailcheck = {
    domainThreshold: 2,
    secondLevelThreshold: 2,
    topLevelThreshold: 2,

    defaultDomains: ['msn.com', 'bellsouth.net',
      'telus.net', 'comcast.net', 'optusnet.com.au',
      'earthlink.net', 'qq.com', 'sky.com', 'icloud.com',
      'mac.com', 'sympatico.ca', 'googlemail.com',
      'att.net', 'xtra.co.nz', 'web.de',
      'cox.net', 'gmail.com', 'ymail.com',
      'aim.com', 'rogers.com', 'verizon.net',
      'rocketmail.com', 'google.com', 'optonline.net',
      'sbcglobal.net', 'aol.com', 'me.com', 'btinternet.com',
      'charter.net', 'shaw.ca'],

    defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],

    defaultTopLevelDomains: ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de",
      "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu",
      "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz",
      "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu"],

    run: function(opts) {
      opts.domains = opts.domains || Mailcheck.defaultDomains;
      opts.secondLevelDomains = opts.secondLevelDomains || Mailcheck.defaultSecondLevelDomains;
      opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
      opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;

      var defaultCallback = function(result){ return result };
      var suggestedCallback = opts.suggested || defaultCallback;
      var emptyCallback = opts.empty || defaultCallback;

      var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.secondLevelDomains, opts.topLevelDomains, opts.distanceFunction);

      return result ? suggestedCallback(result) : emptyCallback()
    },

    suggest: function(email, domains, secondLevelDomains, topLevelDomains, distanceFunction) {
      email = email.toLowerCase();

      var emailParts = this.splitEmail(email);

      if (secondLevelDomains && topLevelDomains) {
          // If the email is a valid 2nd-level + top-level, do not suggest anything.
          if (secondLevelDomains.indexOf(emailParts.secondLevelDomain) !== -1 && topLevelDomains.indexOf(emailParts.topLevelDomain) !== -1) {
              return false;
          }
      }

      var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

      if (closestDomain) {
        if (closestDomain == emailParts.domain) {
          // The email address exactly matches one of the supplied domains; do not return a suggestion.
          return false;
        } else {
          // The email address closely matches one of the supplied domains; return a suggestion
          return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
        }
      }

      // The email address does not closely match one of the supplied domains
      var closestSecondLevelDomain = this.findClosestDomain(emailParts.secondLevelDomain, secondLevelDomains, distanceFunction, this.secondLevelThreshold);
      var closestTopLevelDomain    = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);

      if (emailParts.domain) {
        var closestDomain = emailParts.domain;
        var rtrn = false;

        if(closestSecondLevelDomain && closestSecondLevelDomain != emailParts.secondLevelDomain) {
          // The email address may have a mispelled second-level domain; return a suggestion
          closestDomain = closestDomain.replace(emailParts.secondLevelDomain, closestSecondLevelDomain);
          rtrn = true;
        }

        if(closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
          // The email address may have a mispelled top-level domain; return a suggestion
          closestDomain = closestDomain.replace(emailParts.topLevelDomain, closestTopLevelDomain);
          rtrn = true;
        }

        if (rtrn == true) {
          return { address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain };
        }
      }

      /* The email address exactly matches one of the supplied domains, does not closely
       * match any domain and does not appear to simply have a mispelled top-level domain,
       * or is an invalid email address; do not return a suggestion.
       */
      return false;
    },

    findClosestDomain: function(domain, domains, distanceFunction, threshold) {
      threshold = threshold || this.topLevelThreshold;
      var dist;
      var minDist = 99;
      var closestDomain = null;

      if (!domain || !domains) {
        return false;
      }
      if(!distanceFunction) {
        distanceFunction = this.sift3Distance;
      }

      for (var i = 0; i < domains.length; i++) {
        if (domain === domains[i]) {
          return domain;
        }
        dist = distanceFunction(domain, domains[i]);
        if (dist < minDist) {
          minDist = dist;
          closestDomain = domains[i];
        }
      }

      if (minDist <= threshold && closestDomain !== null) {
        return closestDomain;
      } else {
        return false;
      }
    },

    sift3Distance: function(s1, s2) {
      // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
      if (s1 == null || s1.length === 0) {
        if (s2 == null || s2.length === 0) {
          return 0;
        } else {
          return s2.length;
        }
      }

      if (s2 == null || s2.length === 0) {
        return s1.length;
      }

      var c = 0;
      var offset1 = 0;
      var offset2 = 0;
      var lcs = 0;
      var maxOffset = 5;

      while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
        if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
          lcs++;
        } else {
          offset1 = 0;
          offset2 = 0;
          for (var i = 0; i < maxOffset; i++) {
            if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
              offset1 = i;
              break;
            }
            if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
              offset2 = i;
              break;
            }
          }
        }
        c++;
      }
      return (s1.length + s2.length) /2 - lcs;
    },

    splitEmail: function(email) {
      var parts = email.trim().split('@');

      if (parts.length < 2) {
        return false;
      }

      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === '') {
          return false;
        }
      }

      var domain = parts.pop();
      var domainParts = domain.split('.');
      var sld = '';
      var tld = '';

      if (domainParts.length == 0) {
        // The address does not have a top-level domain
        return false;
      } else if (domainParts.length == 1) {
        // The address has only a top-level domain (valid under RFC)
        tld = domainParts[0];
      } else {
        // The address has a domain and a top-level domain
        sld = domainParts[0];
        for (var i = 1; i < domainParts.length; i++) {
          tld += domainParts[i] + '.';
        }
        tld = tld.substring(0, tld.length - 1);
      }

      return {
        topLevelDomain: tld,
        secondLevelDomain: sld,
        domain: domain,
        address: parts.join('@')
      }
    },

    // Encode the email address to prevent XSS but leave in valid
    // characters, following this official spec:
    // http://en.wikipedia.org/wiki/Email_address#Syntax
    encodeEmail: function(email) {
      var result = encodeURI(email);
      result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
                     .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
                     .replace('%7D', '}');
      return result;
    }
  };

  // Export the mailcheck object if we're in a CommonJS env (e.g. Node).
  // Modeled off of Underscore.js.
  if ( module.exports) {
      module.exports = Mailcheck;
  }

  if (typeof window !== 'undefined' && window.jQuery) {
    (function($){
      $.fn.mailcheck = function(opts) {
        var self = this;
        if (opts.suggested) {
          var oldSuggested = opts.suggested;
          opts.suggested = function(result) {
            oldSuggested(self, result);
          };
        }

        if (opts.empty) {
          var oldEmpty = opts.empty;
          opts.empty = function() {
            oldEmpty.call(null, self);
          };
        }

        opts.email = this.val();
        Mailcheck.run(opts);
      };
    })(jQuery);
  }
  });

  function emailValidate(email) {
      if (!/.+@.+\..+/i.test(email)) {
          return {
              errorMessage: 'Некорректный адрес электронной почты',
              params: {
                  isEmpty: !email,
                  validError: true,
              },
          };
      }
      else {
          if (/\b\d{2}\.ru/i.test(email.split('@')[1]))
              // исключение для email типа "*@66.ru"
              return {
                  errorMessage: '',
                  params: {},
              };
          var domains = [
              'mail.ru',
              'bk.ru',
              'list.ru',
              'inbox.ru',
              'yandex.ru',
              'ya.ru',
              'gmail.com',
              'googlemail.com',
              'outlook.com',
              'hotmail.com',
              'live.ru',
              'live.com',
              'me.com',
              'icloud.com',
              'rambler.ru',
              'yahoo.com',
          ];
          var errorMessage_1 = '';
          var params_1 = {};
          mailcheck.run({
              email: email,
              domains: domains,
              suggested: function (suggestion) {
                  errorMessage_1 = 'Возможно вы ошиблись в доменном имени почты';
                  params_1 = {
                      domainWarning: true,
                  };
              },
              empty: function () {
                  errorMessage_1 = '';
                  params_1 = {};
              },
          });
          return {
              errorMessage: errorMessage_1,
              params: params_1,
          };
      }
  }

  function isEmpty(data) {
      if (data) {
          if (Array.isArray(data) && data.length > 0) {
              return false;
          }
          if (data instanceof Object && Object.keys(data).length > 0) {
              return false;
          }
      }
      return true;
  }
  function isNotEmpty(data) {
      return !isEmpty(data);
  }

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  function unfetch(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return {ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(JSON.parse(s.responseText))},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t;}),t(a());},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null);})}

  var unfetch$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': unfetch
  });

  // Based on https://github.com/tmpvar/jsdom/blob/aa85b2abf07766ff7bf5c1f6daafb3726f2f2db5/lib/jsdom/living/blob.js

  // fix for "Readable" isn't a named export issue
  const Readable = Stream.Readable;

  const BUFFER = Symbol('buffer');
  const TYPE = Symbol('type');

  class Blob$1 {
  	constructor() {
  		this[TYPE] = '';

  		const blobParts = arguments[0];
  		const options = arguments[1];

  		const buffers = [];
  		let size = 0;

  		if (blobParts) {
  			const a = blobParts;
  			const length = Number(a.length);
  			for (let i = 0; i < length; i++) {
  				const element = a[i];
  				let buffer;
  				if (element instanceof Buffer) {
  					buffer = element;
  				} else if (ArrayBuffer.isView(element)) {
  					buffer = Buffer.from(element.buffer, element.byteOffset, element.byteLength);
  				} else if (element instanceof ArrayBuffer) {
  					buffer = Buffer.from(element);
  				} else if (element instanceof Blob$1) {
  					buffer = element[BUFFER];
  				} else {
  					buffer = Buffer.from(typeof element === 'string' ? element : String(element));
  				}
  				size += buffer.length;
  				buffers.push(buffer);
  			}
  		}

  		this[BUFFER] = Buffer.concat(buffers);

  		let type = options && options.type !== undefined && String(options.type).toLowerCase();
  		if (type && !/[^\u0020-\u007E]/.test(type)) {
  			this[TYPE] = type;
  		}
  	}
  	get size() {
  		return this[BUFFER].length;
  	}
  	get type() {
  		return this[TYPE];
  	}
  	text() {
  		return Promise.resolve(this[BUFFER].toString());
  	}
  	arrayBuffer() {
  		const buf = this[BUFFER];
  		const ab = buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
  		return Promise.resolve(ab);
  	}
  	stream() {
  		const readable = new Readable();
  		readable._read = function () {};
  		readable.push(this[BUFFER]);
  		readable.push(null);
  		return readable;
  	}
  	toString() {
  		return '[object Blob]';
  	}
  	slice() {
  		const size = this.size;

  		const start = arguments[0];
  		const end = arguments[1];
  		let relativeStart, relativeEnd;
  		if (start === undefined) {
  			relativeStart = 0;
  		} else if (start < 0) {
  			relativeStart = Math.max(size + start, 0);
  		} else {
  			relativeStart = Math.min(start, size);
  		}
  		if (end === undefined) {
  			relativeEnd = size;
  		} else if (end < 0) {
  			relativeEnd = Math.max(size + end, 0);
  		} else {
  			relativeEnd = Math.min(end, size);
  		}
  		const span = Math.max(relativeEnd - relativeStart, 0);

  		const buffer = this[BUFFER];
  		const slicedBuffer = buffer.slice(relativeStart, relativeStart + span);
  		const blob = new Blob$1([], { type: arguments[2] });
  		blob[BUFFER] = slicedBuffer;
  		return blob;
  	}
  }

  Object.defineProperties(Blob$1.prototype, {
  	size: { enumerable: true },
  	type: { enumerable: true },
  	slice: { enumerable: true }
  });

  Object.defineProperty(Blob$1.prototype, Symbol.toStringTag, {
  	value: 'Blob',
  	writable: false,
  	enumerable: false,
  	configurable: true
  });

  /**
   * fetch-error.js
   *
   * FetchError interface for operational errors
   */

  /**
   * Create FetchError instance
   *
   * @param   String      message      Error message for human
   * @param   String      type         Error type for machine
   * @param   String      systemError  For Node.js system error
   * @return  FetchError
   */
  function FetchError(message, type, systemError) {
    Error.call(this, message);

    this.message = message;
    this.type = type;

    // when err.type is `system`, err.code contains system error code
    if (systemError) {
      this.code = this.errno = systemError.code;
    }

    // hide custom error implementation details from end-users
    Error.captureStackTrace(this, this.constructor);
  }

  FetchError.prototype = Object.create(Error.prototype);
  FetchError.prototype.constructor = FetchError;
  FetchError.prototype.name = 'FetchError';

  let convert;
  try {
  	convert = require('encoding').convert;
  } catch (e) {}

  const INTERNALS = Symbol('Body internals');

  // fix an issue where "PassThrough" isn't a named export for node <10
  const PassThrough = Stream.PassThrough;

  /**
   * Body mixin
   *
   * Ref: https://fetch.spec.whatwg.org/#body
   *
   * @param   Stream  body  Readable stream
   * @param   Object  opts  Response options
   * @return  Void
   */
  function Body(body) {
  	var _this = this;

  	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
  	    _ref$size = _ref.size;

  	let size = _ref$size === undefined ? 0 : _ref$size;
  	var _ref$timeout = _ref.timeout;
  	let timeout = _ref$timeout === undefined ? 0 : _ref$timeout;

  	if (body == null) {
  		// body is undefined or null
  		body = null;
  	} else if (isURLSearchParams(body)) {
  		// body is a URLSearchParams
  		body = Buffer.from(body.toString());
  	} else if (isBlob(body)) ; else if (Buffer.isBuffer(body)) ; else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') {
  		// body is ArrayBuffer
  		body = Buffer.from(body);
  	} else if (ArrayBuffer.isView(body)) {
  		// body is ArrayBufferView
  		body = Buffer.from(body.buffer, body.byteOffset, body.byteLength);
  	} else if (body instanceof Stream) ; else {
  		// none of the above
  		// coerce to string then buffer
  		body = Buffer.from(String(body));
  	}
  	this[INTERNALS] = {
  		body,
  		disturbed: false,
  		error: null
  	};
  	this.size = size;
  	this.timeout = timeout;

  	if (body instanceof Stream) {
  		body.on('error', function (err) {
  			const error = err.name === 'AbortError' ? err : new FetchError(`Invalid response body while trying to fetch ${_this.url}: ${err.message}`, 'system', err);
  			_this[INTERNALS].error = error;
  		});
  	}
  }

  Body.prototype = {
  	get body() {
  		return this[INTERNALS].body;
  	},

  	get bodyUsed() {
  		return this[INTERNALS].disturbed;
  	},

  	/**
    * Decode response as ArrayBuffer
    *
    * @return  Promise
    */
  	arrayBuffer() {
  		return consumeBody.call(this).then(function (buf) {
  			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
  		});
  	},

  	/**
    * Return raw response as Blob
    *
    * @return Promise
    */
  	blob() {
  		let ct = this.headers && this.headers.get('content-type') || '';
  		return consumeBody.call(this).then(function (buf) {
  			return Object.assign(
  			// Prevent copying
  			new Blob$1([], {
  				type: ct.toLowerCase()
  			}), {
  				[BUFFER]: buf
  			});
  		});
  	},

  	/**
    * Decode response as json
    *
    * @return  Promise
    */
  	json() {
  		var _this2 = this;

  		return consumeBody.call(this).then(function (buffer) {
  			try {
  				return JSON.parse(buffer.toString());
  			} catch (err) {
  				return Body.Promise.reject(new FetchError(`invalid json response body at ${_this2.url} reason: ${err.message}`, 'invalid-json'));
  			}
  		});
  	},

  	/**
    * Decode response as text
    *
    * @return  Promise
    */
  	text() {
  		return consumeBody.call(this).then(function (buffer) {
  			return buffer.toString();
  		});
  	},

  	/**
    * Decode response as buffer (non-spec api)
    *
    * @return  Promise
    */
  	buffer() {
  		return consumeBody.call(this);
  	},

  	/**
    * Decode response as text, while automatically detecting the encoding and
    * trying to decode to UTF-8 (non-spec api)
    *
    * @return  Promise
    */
  	textConverted() {
  		var _this3 = this;

  		return consumeBody.call(this).then(function (buffer) {
  			return convertBody(buffer, _this3.headers);
  		});
  	}
  };

  // In browsers, all properties are enumerable.
  Object.defineProperties(Body.prototype, {
  	body: { enumerable: true },
  	bodyUsed: { enumerable: true },
  	arrayBuffer: { enumerable: true },
  	blob: { enumerable: true },
  	json: { enumerable: true },
  	text: { enumerable: true }
  });

  Body.mixIn = function (proto) {
  	for (const name of Object.getOwnPropertyNames(Body.prototype)) {
  		// istanbul ignore else: future proof
  		if (!(name in proto)) {
  			const desc = Object.getOwnPropertyDescriptor(Body.prototype, name);
  			Object.defineProperty(proto, name, desc);
  		}
  	}
  };

  /**
   * Consume and convert an entire Body to a Buffer.
   *
   * Ref: https://fetch.spec.whatwg.org/#concept-body-consume-body
   *
   * @return  Promise
   */
  function consumeBody() {
  	var _this4 = this;

  	if (this[INTERNALS].disturbed) {
  		return Body.Promise.reject(new TypeError(`body used already for: ${this.url}`));
  	}

  	this[INTERNALS].disturbed = true;

  	if (this[INTERNALS].error) {
  		return Body.Promise.reject(this[INTERNALS].error);
  	}

  	let body = this.body;

  	// body is null
  	if (body === null) {
  		return Body.Promise.resolve(Buffer.alloc(0));
  	}

  	// body is blob
  	if (isBlob(body)) {
  		body = body.stream();
  	}

  	// body is buffer
  	if (Buffer.isBuffer(body)) {
  		return Body.Promise.resolve(body);
  	}

  	// istanbul ignore if: should never happen
  	if (!(body instanceof Stream)) {
  		return Body.Promise.resolve(Buffer.alloc(0));
  	}

  	// body is stream
  	// get ready to actually consume the body
  	let accum = [];
  	let accumBytes = 0;
  	let abort = false;

  	return new Body.Promise(function (resolve, reject) {
  		let resTimeout;

  		// allow timeout on slow response body
  		if (_this4.timeout) {
  			resTimeout = setTimeout(function () {
  				abort = true;
  				reject(new FetchError(`Response timeout while trying to fetch ${_this4.url} (over ${_this4.timeout}ms)`, 'body-timeout'));
  			}, _this4.timeout);
  		}

  		// handle stream errors
  		body.on('error', function (err) {
  			if (err.name === 'AbortError') {
  				// if the request was aborted, reject with this Error
  				abort = true;
  				reject(err);
  			} else {
  				// other errors, such as incorrect content-encoding
  				reject(new FetchError(`Invalid response body while trying to fetch ${_this4.url}: ${err.message}`, 'system', err));
  			}
  		});

  		body.on('data', function (chunk) {
  			if (abort || chunk === null) {
  				return;
  			}

  			if (_this4.size && accumBytes + chunk.length > _this4.size) {
  				abort = true;
  				reject(new FetchError(`content size at ${_this4.url} over limit: ${_this4.size}`, 'max-size'));
  				return;
  			}

  			accumBytes += chunk.length;
  			accum.push(chunk);
  		});

  		body.on('end', function () {
  			if (abort) {
  				return;
  			}

  			clearTimeout(resTimeout);

  			try {
  				resolve(Buffer.concat(accum, accumBytes));
  			} catch (err) {
  				// handle streams that have accumulated too much data (issue #414)
  				reject(new FetchError(`Could not create Buffer from response body for ${_this4.url}: ${err.message}`, 'system', err));
  			}
  		});
  	});
  }

  /**
   * Detect buffer encoding and convert to target encoding
   * ref: http://www.w3.org/TR/2011/WD-html5-20110113/parsing.html#determining-the-character-encoding
   *
   * @param   Buffer  buffer    Incoming buffer
   * @param   String  encoding  Target encoding
   * @return  String
   */
  function convertBody(buffer, headers) {
  	if (typeof convert !== 'function') {
  		throw new Error('The package `encoding` must be installed to use the textConverted() function');
  	}

  	const ct = headers.get('content-type');
  	let charset = 'utf-8';
  	let res, str;

  	// header
  	if (ct) {
  		res = /charset=([^;]*)/i.exec(ct);
  	}

  	// no charset in content type, peek at response body for at most 1024 bytes
  	str = buffer.slice(0, 1024).toString();

  	// html5
  	if (!res && str) {
  		res = /<meta.+?charset=(['"])(.+?)\1/i.exec(str);
  	}

  	// html4
  	if (!res && str) {
  		res = /<meta[\s]+?http-equiv=(['"])content-type\1[\s]+?content=(['"])(.+?)\2/i.exec(str);

  		if (res) {
  			res = /charset=(.*)/i.exec(res.pop());
  		}
  	}

  	// xml
  	if (!res && str) {
  		res = /<\?xml.+?encoding=(['"])(.+?)\1/i.exec(str);
  	}

  	// found charset
  	if (res) {
  		charset = res.pop();

  		// prevent decode issues when sites use incorrect encoding
  		// ref: https://hsivonen.fi/encoding-menu/
  		if (charset === 'gb2312' || charset === 'gbk') {
  			charset = 'gb18030';
  		}
  	}

  	// turn raw buffers into a single utf-8 buffer
  	return convert(buffer, 'UTF-8', charset).toString();
  }

  /**
   * Detect a URLSearchParams object
   * ref: https://github.com/bitinn/node-fetch/issues/296#issuecomment-307598143
   *
   * @param   Object  obj     Object to detect by type or brand
   * @return  String
   */
  function isURLSearchParams(obj) {
  	// Duck-typing as a necessary condition.
  	if (typeof obj !== 'object' || typeof obj.append !== 'function' || typeof obj.delete !== 'function' || typeof obj.get !== 'function' || typeof obj.getAll !== 'function' || typeof obj.has !== 'function' || typeof obj.set !== 'function') {
  		return false;
  	}

  	// Brand-checking and more duck-typing as optional condition.
  	return obj.constructor.name === 'URLSearchParams' || Object.prototype.toString.call(obj) === '[object URLSearchParams]' || typeof obj.sort === 'function';
  }

  /**
   * Check if `obj` is a W3C `Blob` object (which `File` inherits from)
   * @param  {*} obj
   * @return {boolean}
   */
  function isBlob(obj) {
  	return typeof obj === 'object' && typeof obj.arrayBuffer === 'function' && typeof obj.type === 'string' && typeof obj.stream === 'function' && typeof obj.constructor === 'function' && typeof obj.constructor.name === 'string' && /^(Blob|File)$/.test(obj.constructor.name) && /^(Blob|File)$/.test(obj[Symbol.toStringTag]);
  }

  /**
   * Clone body given Res/Req instance
   *
   * @param   Mixed  instance  Response or Request instance
   * @return  Mixed
   */
  function clone(instance) {
  	let p1, p2;
  	let body = instance.body;

  	// don't allow cloning a used body
  	if (instance.bodyUsed) {
  		throw new Error('cannot clone body after it is used');
  	}

  	// check that body is a stream and not form-data object
  	// note: we can't clone the form-data object without having it as a dependency
  	if (body instanceof Stream && typeof body.getBoundary !== 'function') {
  		// tee instance body
  		p1 = new PassThrough();
  		p2 = new PassThrough();
  		body.pipe(p1);
  		body.pipe(p2);
  		// set instance body to teed body and return the other teed body
  		instance[INTERNALS].body = p1;
  		body = p2;
  	}

  	return body;
  }

  /**
   * Performs the operation "extract a `Content-Type` value from |object|" as
   * specified in the specification:
   * https://fetch.spec.whatwg.org/#concept-bodyinit-extract
   *
   * This function assumes that instance.body is present.
   *
   * @param   Mixed  instance  Any options.body input
   */
  function extractContentType(body) {
  	if (body === null) {
  		// body is null
  		return null;
  	} else if (typeof body === 'string') {
  		// body is string
  		return 'text/plain;charset=UTF-8';
  	} else if (isURLSearchParams(body)) {
  		// body is a URLSearchParams
  		return 'application/x-www-form-urlencoded;charset=UTF-8';
  	} else if (isBlob(body)) {
  		// body is blob
  		return body.type || null;
  	} else if (Buffer.isBuffer(body)) {
  		// body is buffer
  		return null;
  	} else if (Object.prototype.toString.call(body) === '[object ArrayBuffer]') {
  		// body is ArrayBuffer
  		return null;
  	} else if (ArrayBuffer.isView(body)) {
  		// body is ArrayBufferView
  		return null;
  	} else if (typeof body.getBoundary === 'function') {
  		// detect form data input from form-data module
  		return `multipart/form-data;boundary=${body.getBoundary()}`;
  	} else if (body instanceof Stream) {
  		// body is stream
  		// can't really do much about this
  		return null;
  	} else {
  		// Body constructor defaults other things to string
  		return 'text/plain;charset=UTF-8';
  	}
  }

  /**
   * The Fetch Standard treats this as if "total bytes" is a property on the body.
   * For us, we have to explicitly get it with a function.
   *
   * ref: https://fetch.spec.whatwg.org/#concept-body-total-bytes
   *
   * @param   Body    instance   Instance of Body
   * @return  Number?            Number of bytes, or null if not possible
   */
  function getTotalBytes(instance) {
  	const body = instance.body;


  	if (body === null) {
  		// body is null
  		return 0;
  	} else if (isBlob(body)) {
  		return body.size;
  	} else if (Buffer.isBuffer(body)) {
  		// body is buffer
  		return body.length;
  	} else if (body && typeof body.getLengthSync === 'function') {
  		// detect form data input from form-data module
  		if (body._lengthRetrievers && body._lengthRetrievers.length == 0 || // 1.x
  		body.hasKnownLength && body.hasKnownLength()) {
  			// 2.x
  			return body.getLengthSync();
  		}
  		return null;
  	} else {
  		// body is stream
  		return null;
  	}
  }

  /**
   * Write a Body to a Node.js WritableStream (e.g. http.Request) object.
   *
   * @param   Body    instance   Instance of Body
   * @return  Void
   */
  function writeToStream(dest, instance) {
  	const body = instance.body;


  	if (body === null) {
  		// body is null
  		dest.end();
  	} else if (isBlob(body)) {
  		body.stream().pipe(dest);
  	} else if (Buffer.isBuffer(body)) {
  		// body is buffer
  		dest.write(body);
  		dest.end();
  	} else {
  		// body is stream
  		body.pipe(dest);
  	}
  }

  // expose Promise
  Body.Promise = global.Promise;

  /**
   * headers.js
   *
   * Headers class offers convenient helpers
   */

  const invalidTokenRegex = /[^\^_`a-zA-Z\-0-9!#$%&'*+.|~]/;
  const invalidHeaderCharRegex = /[^\t\x20-\x7e\x80-\xff]/;

  function validateName(name) {
  	name = `${name}`;
  	if (invalidTokenRegex.test(name) || name === '') {
  		throw new TypeError(`${name} is not a legal HTTP header name`);
  	}
  }

  function validateValue(value) {
  	value = `${value}`;
  	if (invalidHeaderCharRegex.test(value)) {
  		throw new TypeError(`${value} is not a legal HTTP header value`);
  	}
  }

  /**
   * Find the key in the map object given a header name.
   *
   * Returns undefined if not found.
   *
   * @param   String  name  Header name
   * @return  String|Undefined
   */
  function find(map, name) {
  	name = name.toLowerCase();
  	for (const key in map) {
  		if (key.toLowerCase() === name) {
  			return key;
  		}
  	}
  	return undefined;
  }

  const MAP = Symbol('map');
  class Headers {
  	/**
    * Headers class
    *
    * @param   Object  headers  Response headers
    * @return  Void
    */
  	constructor() {
  		let init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  		this[MAP] = Object.create(null);

  		if (init instanceof Headers) {
  			const rawHeaders = init.raw();
  			const headerNames = Object.keys(rawHeaders);

  			for (const headerName of headerNames) {
  				for (const value of rawHeaders[headerName]) {
  					this.append(headerName, value);
  				}
  			}

  			return;
  		}

  		// We don't worry about converting prop to ByteString here as append()
  		// will handle it.
  		if (init == null) ; else if (typeof init === 'object') {
  			const method = init[Symbol.iterator];
  			if (method != null) {
  				if (typeof method !== 'function') {
  					throw new TypeError('Header pairs must be iterable');
  				}

  				// sequence<sequence<ByteString>>
  				// Note: per spec we have to first exhaust the lists then process them
  				const pairs = [];
  				for (const pair of init) {
  					if (typeof pair !== 'object' || typeof pair[Symbol.iterator] !== 'function') {
  						throw new TypeError('Each header pair must be iterable');
  					}
  					pairs.push(Array.from(pair));
  				}

  				for (const pair of pairs) {
  					if (pair.length !== 2) {
  						throw new TypeError('Each header pair must be a name/value tuple');
  					}
  					this.append(pair[0], pair[1]);
  				}
  			} else {
  				// record<ByteString, ByteString>
  				for (const key of Object.keys(init)) {
  					const value = init[key];
  					this.append(key, value);
  				}
  			}
  		} else {
  			throw new TypeError('Provided initializer must be an object');
  		}
  	}

  	/**
    * Return combined header value given name
    *
    * @param   String  name  Header name
    * @return  Mixed
    */
  	get(name) {
  		name = `${name}`;
  		validateName(name);
  		const key = find(this[MAP], name);
  		if (key === undefined) {
  			return null;
  		}

  		return this[MAP][key].join(', ');
  	}

  	/**
    * Iterate over all headers
    *
    * @param   Function  callback  Executed for each item with parameters (value, name, thisArg)
    * @param   Boolean   thisArg   `this` context for callback function
    * @return  Void
    */
  	forEach(callback) {
  		let thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  		let pairs = getHeaders(this);
  		let i = 0;
  		while (i < pairs.length) {
  			var _pairs$i = pairs[i];
  			const name = _pairs$i[0],
  			      value = _pairs$i[1];

  			callback.call(thisArg, value, name, this);
  			pairs = getHeaders(this);
  			i++;
  		}
  	}

  	/**
    * Overwrite header values given name
    *
    * @param   String  name   Header name
    * @param   String  value  Header value
    * @return  Void
    */
  	set(name, value) {
  		name = `${name}`;
  		value = `${value}`;
  		validateName(name);
  		validateValue(value);
  		const key = find(this[MAP], name);
  		this[MAP][key !== undefined ? key : name] = [value];
  	}

  	/**
    * Append a value onto existing header
    *
    * @param   String  name   Header name
    * @param   String  value  Header value
    * @return  Void
    */
  	append(name, value) {
  		name = `${name}`;
  		value = `${value}`;
  		validateName(name);
  		validateValue(value);
  		const key = find(this[MAP], name);
  		if (key !== undefined) {
  			this[MAP][key].push(value);
  		} else {
  			this[MAP][name] = [value];
  		}
  	}

  	/**
    * Check for header name existence
    *
    * @param   String   name  Header name
    * @return  Boolean
    */
  	has(name) {
  		name = `${name}`;
  		validateName(name);
  		return find(this[MAP], name) !== undefined;
  	}

  	/**
    * Delete all header values given name
    *
    * @param   String  name  Header name
    * @return  Void
    */
  	delete(name) {
  		name = `${name}`;
  		validateName(name);
  		const key = find(this[MAP], name);
  		if (key !== undefined) {
  			delete this[MAP][key];
  		}
  	}

  	/**
    * Return raw headers (non-spec api)
    *
    * @return  Object
    */
  	raw() {
  		return this[MAP];
  	}

  	/**
    * Get an iterator on keys.
    *
    * @return  Iterator
    */
  	keys() {
  		return createHeadersIterator(this, 'key');
  	}

  	/**
    * Get an iterator on values.
    *
    * @return  Iterator
    */
  	values() {
  		return createHeadersIterator(this, 'value');
  	}

  	/**
    * Get an iterator on entries.
    *
    * This is the default iterator of the Headers object.
    *
    * @return  Iterator
    */
  	[Symbol.iterator]() {
  		return createHeadersIterator(this, 'key+value');
  	}
  }
  Headers.prototype.entries = Headers.prototype[Symbol.iterator];

  Object.defineProperty(Headers.prototype, Symbol.toStringTag, {
  	value: 'Headers',
  	writable: false,
  	enumerable: false,
  	configurable: true
  });

  Object.defineProperties(Headers.prototype, {
  	get: { enumerable: true },
  	forEach: { enumerable: true },
  	set: { enumerable: true },
  	append: { enumerable: true },
  	has: { enumerable: true },
  	delete: { enumerable: true },
  	keys: { enumerable: true },
  	values: { enumerable: true },
  	entries: { enumerable: true }
  });

  function getHeaders(headers) {
  	let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key+value';

  	const keys = Object.keys(headers[MAP]).sort();
  	return keys.map(kind === 'key' ? function (k) {
  		return k.toLowerCase();
  	} : kind === 'value' ? function (k) {
  		return headers[MAP][k].join(', ');
  	} : function (k) {
  		return [k.toLowerCase(), headers[MAP][k].join(', ')];
  	});
  }

  const INTERNAL = Symbol('internal');

  function createHeadersIterator(target, kind) {
  	const iterator = Object.create(HeadersIteratorPrototype);
  	iterator[INTERNAL] = {
  		target,
  		kind,
  		index: 0
  	};
  	return iterator;
  }

  const HeadersIteratorPrototype = Object.setPrototypeOf({
  	next() {
  		// istanbul ignore if
  		if (!this || Object.getPrototypeOf(this) !== HeadersIteratorPrototype) {
  			throw new TypeError('Value of `this` is not a HeadersIterator');
  		}

  		var _INTERNAL = this[INTERNAL];
  		const target = _INTERNAL.target,
  		      kind = _INTERNAL.kind,
  		      index = _INTERNAL.index;

  		const values = getHeaders(target, kind);
  		const len = values.length;
  		if (index >= len) {
  			return {
  				value: undefined,
  				done: true
  			};
  		}

  		this[INTERNAL].index = index + 1;

  		return {
  			value: values[index],
  			done: false
  		};
  	}
  }, Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]())));

  Object.defineProperty(HeadersIteratorPrototype, Symbol.toStringTag, {
  	value: 'HeadersIterator',
  	writable: false,
  	enumerable: false,
  	configurable: true
  });

  /**
   * Export the Headers object in a form that Node.js can consume.
   *
   * @param   Headers  headers
   * @return  Object
   */
  function exportNodeCompatibleHeaders(headers) {
  	const obj = Object.assign({ __proto__: null }, headers[MAP]);

  	// http.request() only supports string as Host header. This hack makes
  	// specifying custom Host header possible.
  	const hostHeaderKey = find(headers[MAP], 'Host');
  	if (hostHeaderKey !== undefined) {
  		obj[hostHeaderKey] = obj[hostHeaderKey][0];
  	}

  	return obj;
  }

  /**
   * Create a Headers object from an object of headers, ignoring those that do
   * not conform to HTTP grammar productions.
   *
   * @param   Object  obj  Object of headers
   * @return  Headers
   */
  function createHeadersLenient(obj) {
  	const headers = new Headers();
  	for (const name of Object.keys(obj)) {
  		if (invalidTokenRegex.test(name)) {
  			continue;
  		}
  		if (Array.isArray(obj[name])) {
  			for (const val of obj[name]) {
  				if (invalidHeaderCharRegex.test(val)) {
  					continue;
  				}
  				if (headers[MAP][name] === undefined) {
  					headers[MAP][name] = [val];
  				} else {
  					headers[MAP][name].push(val);
  				}
  			}
  		} else if (!invalidHeaderCharRegex.test(obj[name])) {
  			headers[MAP][name] = [obj[name]];
  		}
  	}
  	return headers;
  }

  const INTERNALS$1 = Symbol('Response internals');

  // fix an issue where "STATUS_CODES" aren't a named export for node <10
  const STATUS_CODES = http.STATUS_CODES;

  /**
   * Response class
   *
   * @param   Stream  body  Readable stream
   * @param   Object  opts  Response options
   * @return  Void
   */
  class Response {
  	constructor() {
  		let body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  		let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  		Body.call(this, body, opts);

  		const status = opts.status || 200;
  		const headers = new Headers(opts.headers);

  		if (body != null && !headers.has('Content-Type')) {
  			const contentType = extractContentType(body);
  			if (contentType) {
  				headers.append('Content-Type', contentType);
  			}
  		}

  		this[INTERNALS$1] = {
  			url: opts.url,
  			status,
  			statusText: opts.statusText || STATUS_CODES[status],
  			headers,
  			counter: opts.counter
  		};
  	}

  	get url() {
  		return this[INTERNALS$1].url || '';
  	}

  	get status() {
  		return this[INTERNALS$1].status;
  	}

  	/**
    * Convenience property representing if the request ended normally
    */
  	get ok() {
  		return this[INTERNALS$1].status >= 200 && this[INTERNALS$1].status < 300;
  	}

  	get redirected() {
  		return this[INTERNALS$1].counter > 0;
  	}

  	get statusText() {
  		return this[INTERNALS$1].statusText;
  	}

  	get headers() {
  		return this[INTERNALS$1].headers;
  	}

  	/**
    * Clone this response
    *
    * @return  Response
    */
  	clone() {
  		return new Response(clone(this), {
  			url: this.url,
  			status: this.status,
  			statusText: this.statusText,
  			headers: this.headers,
  			ok: this.ok,
  			redirected: this.redirected
  		});
  	}
  }

  Body.mixIn(Response.prototype);

  Object.defineProperties(Response.prototype, {
  	url: { enumerable: true },
  	status: { enumerable: true },
  	ok: { enumerable: true },
  	redirected: { enumerable: true },
  	statusText: { enumerable: true },
  	headers: { enumerable: true },
  	clone: { enumerable: true }
  });

  Object.defineProperty(Response.prototype, Symbol.toStringTag, {
  	value: 'Response',
  	writable: false,
  	enumerable: false,
  	configurable: true
  });

  const INTERNALS$2 = Symbol('Request internals');

  // fix an issue where "format", "parse" aren't a named export for node <10
  const parse_url = Url.parse;
  const format_url = Url.format;

  const streamDestructionSupported = 'destroy' in Stream.Readable.prototype;

  /**
   * Check if a value is an instance of Request.
   *
   * @param   Mixed   input
   * @return  Boolean
   */
  function isRequest(input) {
  	return typeof input === 'object' && typeof input[INTERNALS$2] === 'object';
  }

  function isAbortSignal(signal) {
  	const proto = signal && typeof signal === 'object' && Object.getPrototypeOf(signal);
  	return !!(proto && proto.constructor.name === 'AbortSignal');
  }

  /**
   * Request class
   *
   * @param   Mixed   input  Url or Request instance
   * @param   Object  init   Custom options
   * @return  Void
   */
  class Request {
  	constructor(input) {
  		let init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  		let parsedURL;

  		// normalize input
  		if (!isRequest(input)) {
  			if (input && input.href) {
  				// in order to support Node.js' Url objects; though WHATWG's URL objects
  				// will fall into this branch also (since their `toString()` will return
  				// `href` property anyway)
  				parsedURL = parse_url(input.href);
  			} else {
  				// coerce input to a string before attempting to parse
  				parsedURL = parse_url(`${input}`);
  			}
  			input = {};
  		} else {
  			parsedURL = parse_url(input.url);
  		}

  		let method = init.method || input.method || 'GET';
  		method = method.toUpperCase();

  		if ((init.body != null || isRequest(input) && input.body !== null) && (method === 'GET' || method === 'HEAD')) {
  			throw new TypeError('Request with GET/HEAD method cannot have body');
  		}

  		let inputBody = init.body != null ? init.body : isRequest(input) && input.body !== null ? clone(input) : null;

  		Body.call(this, inputBody, {
  			timeout: init.timeout || input.timeout || 0,
  			size: init.size || input.size || 0
  		});

  		const headers = new Headers(init.headers || input.headers || {});

  		if (inputBody != null && !headers.has('Content-Type')) {
  			const contentType = extractContentType(inputBody);
  			if (contentType) {
  				headers.append('Content-Type', contentType);
  			}
  		}

  		let signal = isRequest(input) ? input.signal : null;
  		if ('signal' in init) signal = init.signal;

  		if (signal != null && !isAbortSignal(signal)) {
  			throw new TypeError('Expected signal to be an instanceof AbortSignal');
  		}

  		this[INTERNALS$2] = {
  			method,
  			redirect: init.redirect || input.redirect || 'follow',
  			headers,
  			parsedURL,
  			signal
  		};

  		// node-fetch-only options
  		this.follow = init.follow !== undefined ? init.follow : input.follow !== undefined ? input.follow : 20;
  		this.compress = init.compress !== undefined ? init.compress : input.compress !== undefined ? input.compress : true;
  		this.counter = init.counter || input.counter || 0;
  		this.agent = init.agent || input.agent;
  	}

  	get method() {
  		return this[INTERNALS$2].method;
  	}

  	get url() {
  		return format_url(this[INTERNALS$2].parsedURL);
  	}

  	get headers() {
  		return this[INTERNALS$2].headers;
  	}

  	get redirect() {
  		return this[INTERNALS$2].redirect;
  	}

  	get signal() {
  		return this[INTERNALS$2].signal;
  	}

  	/**
    * Clone this request
    *
    * @return  Request
    */
  	clone() {
  		return new Request(this);
  	}
  }

  Body.mixIn(Request.prototype);

  Object.defineProperty(Request.prototype, Symbol.toStringTag, {
  	value: 'Request',
  	writable: false,
  	enumerable: false,
  	configurable: true
  });

  Object.defineProperties(Request.prototype, {
  	method: { enumerable: true },
  	url: { enumerable: true },
  	headers: { enumerable: true },
  	redirect: { enumerable: true },
  	clone: { enumerable: true },
  	signal: { enumerable: true }
  });

  /**
   * Convert a Request to Node.js http request options.
   *
   * @param   Request  A Request instance
   * @return  Object   The options object to be passed to http.request
   */
  function getNodeRequestOptions(request) {
  	const parsedURL = request[INTERNALS$2].parsedURL;
  	const headers = new Headers(request[INTERNALS$2].headers);

  	// fetch step 1.3
  	if (!headers.has('Accept')) {
  		headers.set('Accept', '*/*');
  	}

  	// Basic fetch
  	if (!parsedURL.protocol || !parsedURL.hostname) {
  		throw new TypeError('Only absolute URLs are supported');
  	}

  	if (!/^https?:$/.test(parsedURL.protocol)) {
  		throw new TypeError('Only HTTP(S) protocols are supported');
  	}

  	if (request.signal && request.body instanceof Stream.Readable && !streamDestructionSupported) {
  		throw new Error('Cancellation of streamed requests with AbortSignal is not supported in node < 8');
  	}

  	// HTTP-network-or-cache fetch steps 2.4-2.7
  	let contentLengthValue = null;
  	if (request.body == null && /^(POST|PUT)$/i.test(request.method)) {
  		contentLengthValue = '0';
  	}
  	if (request.body != null) {
  		const totalBytes = getTotalBytes(request);
  		if (typeof totalBytes === 'number') {
  			contentLengthValue = String(totalBytes);
  		}
  	}
  	if (contentLengthValue) {
  		headers.set('Content-Length', contentLengthValue);
  	}

  	// HTTP-network-or-cache fetch step 2.11
  	if (!headers.has('User-Agent')) {
  		headers.set('User-Agent', 'node-fetch/1.0 (+https://github.com/bitinn/node-fetch)');
  	}

  	// HTTP-network-or-cache fetch step 2.15
  	if (request.compress && !headers.has('Accept-Encoding')) {
  		headers.set('Accept-Encoding', 'gzip,deflate');
  	}

  	let agent = request.agent;
  	if (typeof agent === 'function') {
  		agent = agent(parsedURL);
  	}

  	if (!headers.has('Connection') && !agent) {
  		headers.set('Connection', 'close');
  	}

  	// HTTP-network fetch step 4.2
  	// chunked encoding is handled by Node.js

  	return Object.assign({}, parsedURL, {
  		method: request.method,
  		headers: exportNodeCompatibleHeaders(headers),
  		agent
  	});
  }

  /**
   * abort-error.js
   *
   * AbortError interface for cancelled requests
   */

  /**
   * Create AbortError instance
   *
   * @param   String      message      Error message for human
   * @return  AbortError
   */
  function AbortError(message) {
    Error.call(this, message);

    this.type = 'aborted';
    this.message = message;

    // hide custom error implementation details from end-users
    Error.captureStackTrace(this, this.constructor);
  }

  AbortError.prototype = Object.create(Error.prototype);
  AbortError.prototype.constructor = AbortError;
  AbortError.prototype.name = 'AbortError';

  // fix an issue where "PassThrough", "resolve" aren't a named export for node <10
  const PassThrough$1 = Stream.PassThrough;
  const resolve_url = Url.resolve;

  /**
   * Fetch function
   *
   * @param   Mixed    url   Absolute url or Request instance
   * @param   Object   opts  Fetch options
   * @return  Promise
   */
  function fetch(url, opts) {

  	// allow custom promise
  	if (!fetch.Promise) {
  		throw new Error('native promise missing, set fetch.Promise to your favorite alternative');
  	}

  	Body.Promise = fetch.Promise;

  	// wrap http.request into fetch
  	return new fetch.Promise(function (resolve, reject) {
  		// build request object
  		const request = new Request(url, opts);
  		const options = getNodeRequestOptions(request);

  		const send = (options.protocol === 'https:' ? https : http).request;
  		const signal = request.signal;

  		let response = null;

  		const abort = function abort() {
  			let error = new AbortError('The user aborted a request.');
  			reject(error);
  			if (request.body && request.body instanceof Stream.Readable) {
  				request.body.destroy(error);
  			}
  			if (!response || !response.body) return;
  			response.body.emit('error', error);
  		};

  		if (signal && signal.aborted) {
  			abort();
  			return;
  		}

  		const abortAndFinalize = function abortAndFinalize() {
  			abort();
  			finalize();
  		};

  		// send request
  		const req = send(options);
  		let reqTimeout;

  		if (signal) {
  			signal.addEventListener('abort', abortAndFinalize);
  		}

  		function finalize() {
  			req.abort();
  			if (signal) signal.removeEventListener('abort', abortAndFinalize);
  			clearTimeout(reqTimeout);
  		}

  		if (request.timeout) {
  			req.once('socket', function (socket) {
  				reqTimeout = setTimeout(function () {
  					reject(new FetchError(`network timeout at: ${request.url}`, 'request-timeout'));
  					finalize();
  				}, request.timeout);
  			});
  		}

  		req.on('error', function (err) {
  			reject(new FetchError(`request to ${request.url} failed, reason: ${err.message}`, 'system', err));
  			finalize();
  		});

  		req.on('response', function (res) {
  			clearTimeout(reqTimeout);

  			const headers = createHeadersLenient(res.headers);

  			// HTTP fetch step 5
  			if (fetch.isRedirect(res.statusCode)) {
  				// HTTP fetch step 5.2
  				const location = headers.get('Location');

  				// HTTP fetch step 5.3
  				const locationURL = location === null ? null : resolve_url(request.url, location);

  				// HTTP fetch step 5.5
  				switch (request.redirect) {
  					case 'error':
  						reject(new FetchError(`redirect mode is set to error: ${request.url}`, 'no-redirect'));
  						finalize();
  						return;
  					case 'manual':
  						// node-fetch-specific step: make manual redirect a bit easier to use by setting the Location header value to the resolved URL.
  						if (locationURL !== null) {
  							// handle corrupted header
  							try {
  								headers.set('Location', locationURL);
  							} catch (err) {
  								// istanbul ignore next: nodejs server prevent invalid response headers, we can't test this through normal request
  								reject(err);
  							}
  						}
  						break;
  					case 'follow':
  						// HTTP-redirect fetch step 2
  						if (locationURL === null) {
  							break;
  						}

  						// HTTP-redirect fetch step 5
  						if (request.counter >= request.follow) {
  							reject(new FetchError(`maximum redirect reached at: ${request.url}`, 'max-redirect'));
  							finalize();
  							return;
  						}

  						// HTTP-redirect fetch step 6 (counter increment)
  						// Create a new Request object.
  						const requestOpts = {
  							headers: new Headers(request.headers),
  							follow: request.follow,
  							counter: request.counter + 1,
  							agent: request.agent,
  							compress: request.compress,
  							method: request.method,
  							body: request.body,
  							signal: request.signal,
  							timeout: request.timeout
  						};

  						// HTTP-redirect fetch step 9
  						if (res.statusCode !== 303 && request.body && getTotalBytes(request) === null) {
  							reject(new FetchError('Cannot follow redirect with body being a readable stream', 'unsupported-redirect'));
  							finalize();
  							return;
  						}

  						// HTTP-redirect fetch step 11
  						if (res.statusCode === 303 || (res.statusCode === 301 || res.statusCode === 302) && request.method === 'POST') {
  							requestOpts.method = 'GET';
  							requestOpts.body = undefined;
  							requestOpts.headers.delete('content-length');
  						}

  						// HTTP-redirect fetch step 15
  						resolve(fetch(new Request(locationURL, requestOpts)));
  						finalize();
  						return;
  				}
  			}

  			// prepare response
  			res.once('end', function () {
  				if (signal) signal.removeEventListener('abort', abortAndFinalize);
  			});
  			let body = res.pipe(new PassThrough$1());

  			const response_options = {
  				url: request.url,
  				status: res.statusCode,
  				statusText: res.statusMessage,
  				headers: headers,
  				size: request.size,
  				timeout: request.timeout,
  				counter: request.counter
  			};

  			// HTTP-network fetch step 12.1.1.3
  			const codings = headers.get('Content-Encoding');

  			// HTTP-network fetch step 12.1.1.4: handle content codings

  			// in following scenarios we ignore compression support
  			// 1. compression support is disabled
  			// 2. HEAD request
  			// 3. no Content-Encoding header
  			// 4. no content response (204)
  			// 5. content not modified response (304)
  			if (!request.compress || request.method === 'HEAD' || codings === null || res.statusCode === 204 || res.statusCode === 304) {
  				response = new Response(body, response_options);
  				resolve(response);
  				return;
  			}

  			// For Node v6+
  			// Be less strict when decoding compressed responses, since sometimes
  			// servers send slightly invalid responses that are still accepted
  			// by common browsers.
  			// Always using Z_SYNC_FLUSH is what cURL does.
  			const zlibOptions = {
  				flush: zlib.Z_SYNC_FLUSH,
  				finishFlush: zlib.Z_SYNC_FLUSH
  			};

  			// for gzip
  			if (codings == 'gzip' || codings == 'x-gzip') {
  				body = body.pipe(zlib.createGunzip(zlibOptions));
  				response = new Response(body, response_options);
  				resolve(response);
  				return;
  			}

  			// for deflate
  			if (codings == 'deflate' || codings == 'x-deflate') {
  				// handle the infamous raw deflate response from old servers
  				// a hack for old IIS and Apache servers
  				const raw = res.pipe(new PassThrough$1());
  				raw.once('data', function (chunk) {
  					// see http://stackoverflow.com/questions/37519828
  					if ((chunk[0] & 0x0F) === 0x08) {
  						body = body.pipe(zlib.createInflate());
  					} else {
  						body = body.pipe(zlib.createInflateRaw());
  					}
  					response = new Response(body, response_options);
  					resolve(response);
  				});
  				return;
  			}

  			// for br
  			if (codings == 'br' && typeof zlib.createBrotliDecompress === 'function') {
  				body = body.pipe(zlib.createBrotliDecompress());
  				response = new Response(body, response_options);
  				resolve(response);
  				return;
  			}

  			// otherwise, use response as-is
  			response = new Response(body, response_options);
  			resolve(response);
  		});

  		writeToStream(req, request);
  	});
  }
  /**
   * Redirect code matching
   *
   * @param   Number   code  Status code
   * @return  Boolean
   */
  fetch.isRedirect = function (code) {
  	return code === 301 || code === 302 || code === 303 || code === 307 || code === 308;
  };

  // expose Promise
  fetch.Promise = global.Promise;

  var lib = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': fetch,
    Headers: Headers,
    Request: Request,
    Response: Response,
    FetchError: FetchError
  });

  var require$$0 = getCjsExportFromNamespace(unfetch$1);

  var require$$1 = getCjsExportFromNamespace(lib);

  var isomorphicUnfetch = commonjsGlobal.fetch = commonjsGlobal.fetch || (
  	typeof process=='undefined' ? (require$$0.default || require$$0) : (function(url, opts) {
  		return require$$1(url.replace(/^\/\//g,'https://'), opts);
  	})
  );

  function fetchJSON(baseAuthorization) {
      return function (url, options) {
          return __awaiter(this, void 0, void 0, function () {
              var headers, response, text, data;
              return __generator(this, function (_a) {
                  switch (_a.label) {
                      case 0:
                          headers = {
                              'content-type': 'application/json',
                              Accept: 'application/json',
                          };
                          if (baseAuthorization) {
                              headers.Authorization = baseAuthorization;
                          }
                          return [4 /*yield*/, isomorphicUnfetch(url, __assign({ headers: headers }, options))];
                      case 1:
                          response = _a.sent();
                          if (response.status === 204 && response.statusText === 'No Content') {
                              return [2 /*return*/];
                          }
                          return [4 /*yield*/, response.text()];
                      case 2:
                          text = _a.sent();
                          try {
                              data = JSON.parse(text);
                          }
                          catch (error) {
                              throw { response: response, error: data }; // eslint-disable-line
                          }
                          if (response.ok) {
                              return [2 /*return*/, data];
                          }
                          throw { response: response, error: data }; // eslint-disable-line
                  }
              });
          });
      };
  }

  var lscache = createCommonjsModule(function (module) {
  /**
   * lscache library
   * Copyright (c) 2011, Pamela Fox
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *       http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */

  /* jshint undef:true, browser:true, node:true */
  /* global define */

  (function (root, factory) {
      if ( module.exports) {
          // CommonJS/Node module
          module.exports = factory();
      } else {
          // Browser globals
          root.lscache = factory();
      }
  }(commonjsGlobal, function () {

    // Prefix for all lscache keys
    var CACHE_PREFIX = 'lscache-';

    // Suffix for the key name on the expiration items in localStorage
    var CACHE_SUFFIX = '-cacheexpiration';

    // expiration date radix (set to Base-36 for most space savings)
    var EXPIRY_RADIX = 10;

    // time resolution in milliseconds
    var expiryMilliseconds = 60 * 1000;
    // ECMAScript max Date (epoch + 1e8 days)
    var maxDate = calculateMaxDate(expiryMilliseconds);

    var cachedStorage;
    var cachedJSON;
    var cacheBucket = '';
    var warnings = false;

    // Determines if localStorage is supported in the browser;
    // result is cached for better performance instead of being run each time.
    // Feature detection is based on how Modernizr does it;
    // it's not straightforward due to FF4 issues.
    // It's not run at parse-time as it takes 200ms in Android.
    function supportsStorage() {
      var key = '__lscachetest__';
      var value = key;

      if (cachedStorage !== undefined) {
        return cachedStorage;
      }

      // some browsers will throw an error if you try to access local storage (e.g. brave browser)
      // hence check is inside a try/catch
      try {
        if (!localStorage) {
          return false;
        }
      } catch (ex) {
        return false;
      }

      try {
        setItem(key, value);
        removeItem(key);
        cachedStorage = true;
      } catch (e) {
          // If we hit the limit, and we don't have an empty localStorage then it means we have support
          if (isOutOfSpace(e) && localStorage.length) {
              cachedStorage = true; // just maxed it out and even the set test failed.
          } else {
              cachedStorage = false;
          }
      }
      return cachedStorage;
    }

    // Check to set if the error is us dealing with being out of space
    function isOutOfSpace(e) {
      return e && (
        e.name === 'QUOTA_EXCEEDED_ERR' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
        e.name === 'QuotaExceededError'
      );
    }

    // Determines if native JSON (de-)serialization is supported in the browser.
    function supportsJSON() {
      /*jshint eqnull:true */
      if (cachedJSON === undefined) {
        cachedJSON = (window.JSON != null);
      }
      return cachedJSON;
    }

    /**
     * Returns a string where all RegExp special characters are escaped with a \.
     * @param {String} text
     * @return {string}
     */
    function escapeRegExpSpecialCharacters(text) {
      return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
    }

    /**
     * Returns the full string for the localStorage expiration item.
     * @param {String} key
     * @return {string}
     */
    function expirationKey(key) {
      return key + CACHE_SUFFIX;
    }

    /**
     * Returns the number of minutes since the epoch.
     * @return {number}
     */
    function currentTime() {
      return Math.floor((new Date().getTime())/expiryMilliseconds);
    }

    /**
     * Wrapper functions for localStorage methods
     */

    function getItem(key) {
      return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }

    function setItem(key, value) {
      // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
      localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
      localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }

    function removeItem(key) {
      localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }

    function eachKey(fn) {
      var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
      // Loop in reverse as removing items will change indices of tail
      for (var i = localStorage.length-1; i >= 0 ; --i) {
        var key = localStorage.key(i);
        key = key && key.match(prefixRegExp);
        key = key && key[1];
        if (key && key.indexOf(CACHE_SUFFIX) < 0) {
          fn(key, expirationKey(key));
        }
      }
    }

    function flushItem(key) {
      var exprKey = expirationKey(key);

      removeItem(key);
      removeItem(exprKey);
    }

    function flushExpiredItem(key) {
      var exprKey = expirationKey(key);
      var expr = getItem(exprKey);

      if (expr) {
        var expirationTime = parseInt(expr, EXPIRY_RADIX);

        // Check if we should actually kick item out of storage
        if (currentTime() >= expirationTime) {
          removeItem(key);
          removeItem(exprKey);
          return true;
        }
      }
    }

    function warn(message, err) {
      if (!warnings) return;
      if (!('console' in window) || typeof window.console.warn !== 'function') return;
      window.console.warn("lscache - " + message);
      if (err) window.console.warn("lscache - The error was: " + err.message);
    }

    function calculateMaxDate(expiryMilliseconds) {
      return Math.floor(8.64e15/expiryMilliseconds);
    }

    var lscache = {
      /**
       * Stores the value in localStorage. Expires after specified number of minutes.
       * @param {string} key
       * @param {Object|string} value
       * @param {number} time
       * @return true if the value was inserted successfully
       */
      set: function(key, value, time) {
        if (!supportsStorage()) return false;

        // If we don't get a string value, try to stringify
        // In future, localStorage may properly support storing non-strings
        // and this can be removed.

        if (!supportsJSON()) return false;
        try {
          value = JSON.stringify(value);
        } catch (e) {
          // Sometimes we can't stringify due to circular refs
          // in complex objects, so we won't bother storing then.
          return false;
        }

        try {
          setItem(key, value);
        } catch (e) {
          if (isOutOfSpace(e)) {
            // If we exceeded the quota, then we will sort
            // by the expire time, and then remove the N oldest
            var storedKeys = [];
            var storedKey;
            eachKey(function(key, exprKey) {
              var expiration = getItem(exprKey);
              if (expiration) {
                expiration = parseInt(expiration, EXPIRY_RADIX);
              } else {
                // TODO: Store date added for non-expiring items for smarter removal
                expiration = maxDate;
              }
              storedKeys.push({
                key: key,
                size: (getItem(key) || '').length,
                expiration: expiration
              });
            });
            // Sorts the keys with oldest expiration time last
            storedKeys.sort(function(a, b) { return (b.expiration-a.expiration); });

            var targetSize = (value||'').length;
            while (storedKeys.length && targetSize > 0) {
              storedKey = storedKeys.pop();
              warn("Cache is full, removing item with key '" + key + "'");
              flushItem(storedKey.key);
              targetSize -= storedKey.size;
            }
            try {
              setItem(key, value);
            } catch (e) {
              // value may be larger than total quota
              warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
              return false;
            }
          } else {
            // If it was some other error, just give up.
            warn("Could not add item with key '" + key + "'", e);
            return false;
          }
        }

        // If a time is specified, store expiration info in localStorage
        if (time) {
          setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
        } else {
          // In case they previously set a time, remove that info from localStorage.
          removeItem(expirationKey(key));
        }
        return true;
      },

      /**
       * Retrieves specified value from localStorage, if not expired.
       * @param {string} key
       * @return {string|Object}
       */
      get: function(key) {
        if (!supportsStorage()) return null;

        // Return the de-serialized item if not expired
        if (flushExpiredItem(key)) { return null; }

        // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
        var value = getItem(key);
        if (!value || !supportsJSON()) {
          return value;
        }

        try {
          // We can't tell if its JSON or a string, so we try to parse
          return JSON.parse(value);
        } catch (e) {
          // If we can't parse, it's probably because it isn't an object
          return value;
        }
      },

      /**
       * Removes a value from localStorage.
       * Equivalent to 'delete' in memcache, but that's a keyword in JS.
       * @param {string} key
       */
      remove: function(key) {
        if (!supportsStorage()) return;

        flushItem(key);
      },

      /**
       * Returns whether local storage is supported.
       * Currently exposed for testing purposes.
       * @return {boolean}
       */
      supported: function() {
        return supportsStorage();
      },

      /**
       * Flushes all lscache items and expiry markers without affecting rest of localStorage
       */
      flush: function() {
        if (!supportsStorage()) return;

        eachKey(function(key) {
          flushItem(key);
        });
      },

      /**
       * Flushes expired lscache items and expiry markers without affecting rest of localStorage
       */
      flushExpired: function() {
        if (!supportsStorage()) return;

        eachKey(function(key) {
          flushExpiredItem(key);
        });
      },

      /**
       * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
       * @param {string} bucket
       */
      setBucket: function(bucket) {
        cacheBucket = bucket;
      },

      /**
       * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
       */
      resetBucket: function() {
        cacheBucket = '';
      },

      /**
       * @returns {number} The currently set number of milliseconds each time unit represents in
       *   the set() function's "time" argument.
       */
      getExpiryMilliseconds: function() {
        return expiryMilliseconds;
      },

      /**
       * Sets the number of milliseconds each time unit represents in the set() function's
       *   "time" argument.
       * Sample values:
       *  1: each time unit = 1 millisecond
       *  1000: each time unit = 1 second
       *  60000: each time unit = 1 minute (Default value)
       *  360000: each time unit = 1 hour
       * @param {number} milliseconds
       */
      setExpiryMilliseconds: function(milliseconds) {
          expiryMilliseconds = milliseconds;
          maxDate = calculateMaxDate(expiryMilliseconds);
      },

      /**
       * Sets whether to display warnings when an item is removed from the cache or not.
       */
      enableWarnings: function(enabled) {
        warnings = enabled;
      }
    };

    // Return the module
    return lscache;
  }));
  });

  function fetchWithCache(baseAuthorization) {
      var fetchJSON$1 = fetchJSON(baseAuthorization);
      return function (url, options) {
          return __awaiter(this, void 0, void 0, function () {
              var ttlMinutes, response, cachedResponse;
              return __generator(this, function (_a) {
                  switch (_a.label) {
                      case 0:
                          ttlMinutes = 5;
                          if (!!process.browser) return [3 /*break*/, 2];
                          return [4 /*yield*/, fetchJSON$1(url, options)];
                      case 1:
                          response = _a.sent();
                          lscache.set(url, response, ttlMinutes);
                          return [2 /*return*/, response];
                      case 2:
                          cachedResponse = lscache.get(url);
                          if (!(cachedResponse === null)) return [3 /*break*/, 4];
                          return [4 /*yield*/, fetchJSON$1(url, options)];
                      case 3:
                          cachedResponse = _a.sent();
                          lscache.set(url, cachedResponse, ttlMinutes);
                          _a.label = 4;
                      case 4: return [2 /*return*/, cachedResponse];
                  }
              });
          });
      };
  }

  function breaksHundreds(value) {
      return ("" + value).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
  }

  function getWordEnding(value, ending) {
      value = value.toString();
      var num = value.slice(value.length - 2);
      if (num === '11' || num === '12' || num === '13' || num === '14') {
          return ending[2];
      }
      num = value.slice(-1);
      if (num === '1') {
          return ending[0];
      }
      else if (num === '2' || num === '3' || num === '4') {
          return ending[1];
      }
      else {
          return ending[2];
      }
  }

  var localeOptions = {
      locale: locale.ru,
  };
  function formatPublicDate(date, options) {
      if (options === void 0) { options = {}; }
      var _a = options.hideСurrentYear, hideСurrentYear = _a === void 0 ? true : _a, withTime = options.withTime, isFull = options.isFull;
      var dateParse = new Date(date);
      var time = "" + dateFns.format(dateParse, 'p', localeOptions);
      if (!isFull) {
          if (dateFns.isToday(dateParse))
              return {
                  date: 'Сегодня',
                  year: '',
                  time: withTime ? time : undefined,
              };
          if (dateFns.isYesterday(dateParse))
              return {
                  date: 'Вчера',
                  year: '',
                  time: withTime ? time : undefined,
              };
      }
      return {
          date: dateFns.format(dateParse, 'd MMMM', localeOptions),
          year: hideСurrentYear && dateFns.isThisYear(dateParse) ? '' : "" + dateFns.getYear(dateParse),
          time: withTime ? time : undefined,
      };
  }

  function getCurrentUrl(ctx) {
      if (typeof window !== 'undefined') {
          return "" + window.location.origin + ctx.asPath;
      }
      if (ctx.req) {
          return "http" + (process.env.NODE_ENV === 'development' ? '' : 's') + "://" + ctx.req.headers.host + ctx.req.url;
      }
      return '/';
  }

  function getHost(ctx) {
      var hostFromServer = ctx.req ? ctx.req.headers.host : '';
      var hostFromBrowser = process.browser ? window.location.host : '';
      var host = hostFromServer || hostFromBrowser;
      return "http" + (process.env.NODE_ENV === 'development' ? '' : 's') + "://" + host;
  }

  function handingServerError(ctx, error) {
      var statusCode = error.response ? error.response.status : 500;
      console.error('Status code:', statusCode, error);
      if (ctx.res) {
          ctx.res.statusCode = statusCode;
      }
      return {
          code: statusCode,
          message: error && error.response ? error.response.statusText : '',
      };
  }

  var COMPLETE = 'complete',
      CANCELED = 'canceled';

  function raf(task){
      if('requestAnimationFrame' in window){
          return window.requestAnimationFrame(task);
      }

      setTimeout(task, 16);
  }

  function setElementScroll(element, x, y){
      if(element.self === element){
          element.scrollTo(x, y);
      }else {
          element.scrollLeft = x;
          element.scrollTop = y;
      }
  }

  function getTargetScrollLocation(scrollSettings, parent){
      var align = scrollSettings.align,
          target = scrollSettings.target,
          targetPosition = target.getBoundingClientRect(),
          parentPosition,
          x,
          y,
          differenceX,
          differenceY,
          targetWidth,
          targetHeight,
          leftAlign = align && align.left != null ? align.left : 0.5,
          topAlign = align && align.top != null ? align.top : 0.5,
          leftOffset = align && align.leftOffset != null ? align.leftOffset : 0,
          topOffset = align && align.topOffset != null ? align.topOffset : 0,
          leftScalar = leftAlign,
          topScalar = topAlign;

      if(scrollSettings.isWindow(parent)){
          targetWidth = Math.min(targetPosition.width, parent.innerWidth);
          targetHeight = Math.min(targetPosition.height, parent.innerHeight);
          x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar;
          y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar;
          x -= leftOffset;
          y -= topOffset;
          differenceX = x - parent.pageXOffset;
          differenceY = y - parent.pageYOffset;
      }else {
          targetWidth = targetPosition.width;
          targetHeight = targetPosition.height;
          parentPosition = parent.getBoundingClientRect();
          var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
          var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
          x = offsetLeft + (targetWidth * leftScalar) - parent.clientWidth * leftScalar;
          y = offsetTop + (targetHeight * topScalar) - parent.clientHeight * topScalar;
          x -= leftOffset;
          y -= topOffset;
          x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
          y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
          differenceX = x - parent.scrollLeft;
          differenceY = y - parent.scrollTop;
      }

      return {
          x: x,
          y: y,
          differenceX: differenceX,
          differenceY: differenceY
      };
  }

  function animate(parent){
      var scrollSettings = parent._scrollSettings;

      if(!scrollSettings){
          return;
      }

      var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments;

      var location = getTargetScrollLocation(scrollSettings, parent),
          time = Date.now() - scrollSettings.startTime,
          timeValue = Math.min(1 / scrollSettings.time * time, 1);

      if(scrollSettings.endIterations >= maxSynchronousAlignments){
          setElementScroll(parent, location.x, location.y);
          parent._scrollSettings = null;
          return scrollSettings.end(COMPLETE);
      }

      var easeValue = 1 - scrollSettings.ease(timeValue);

      setElementScroll(parent,
          location.x - location.differenceX * easeValue,
          location.y - location.differenceY * easeValue
      );

      if(time >= scrollSettings.time){
          scrollSettings.endIterations++;
          return animate(parent);
      }

      raf(animate.bind(null, parent));
  }

  function defaultIsWindow(target){
      return target.self === target
  }

  function transitionScrollTo(target, parent, settings, callback){
      var idle = !parent._scrollSettings,
          lastSettings = parent._scrollSettings,
          now = Date.now(),
          cancelHandler,
          passiveOptions = { passive: true };

      if(lastSettings){
          lastSettings.end(CANCELED);
      }

      function end(endType){
          parent._scrollSettings = null;

          if(parent.parentElement && parent.parentElement._scrollSettings){
              parent.parentElement._scrollSettings.end(endType);
          }

          if(settings.debug){
              console.log('Scrolling ended with type', endType, 'for', parent);
          }

          callback(endType);
          if(cancelHandler){
              parent.removeEventListener('touchstart', cancelHandler, passiveOptions);
              parent.removeEventListener('wheel', cancelHandler, passiveOptions);
          }
      }

      var maxSynchronousAlignments = settings.maxSynchronousAlignments;

      if(maxSynchronousAlignments == null){
          maxSynchronousAlignments = 3;
      }

      parent._scrollSettings = {
          startTime: now,
          endIterations: 0,
          target: target,
          time: settings.time,
          ease: settings.ease,
          align: settings.align,
          isWindow: settings.isWindow || defaultIsWindow,
          maxSynchronousAlignments: maxSynchronousAlignments,
          end: end
      };

      if(!('cancellable' in settings) || settings.cancellable){
          cancelHandler = end.bind(null, CANCELED);
          parent.addEventListener('touchstart', cancelHandler, passiveOptions);
          parent.addEventListener('wheel', cancelHandler, passiveOptions);
      }

      if(idle){
          animate(parent);
      }

      return cancelHandler
  }

  function defaultIsScrollable(element){
      return (
          'pageXOffset' in element ||
          (
              element.scrollHeight !== element.clientHeight ||
              element.scrollWidth !== element.clientWidth
          ) &&
          getComputedStyle(element).overflow !== 'hidden'
      );
  }

  function defaultValidTarget(){
      return true;
  }

  function findParentElement(el){
      if (el.assignedSlot) {
          return findParentElement(el.assignedSlot);
      }

      if (el.parentElement) {
          if(el.parentElement.tagName === 'BODY'){
              return el.parentElement.ownerDocument.defaultView || el.parentElement.ownerDocument.ownerWindow;
          }
          return el.parentElement;
      }

      if (el.getRootNode){
          var parent = el.getRootNode();
          if(parent.nodeType === 11) {
              return parent.host;
          }
      }
  }

  var scrollIntoView = function(target, settings, callback){
      if(!target){
          return;
      }

      if(typeof settings === 'function'){
          callback = settings;
          settings = null;
      }

      if(!settings){
          settings = {};
      }

      settings.time = isNaN(settings.time) ? 1000 : settings.time;
      settings.ease = settings.ease || function(v){return 1 - Math.pow(1 - v, v / 2);};

      var parent = findParentElement(target),
          parents = 1;

      function done(endType){
          parents--;
          if(!parents){
              callback && callback(endType);
          }
      }

      var validTarget = settings.validTarget || defaultValidTarget;
      var isScrollable = settings.isScrollable;

      if(settings.debug){
          console.log('About to scroll to', target);

          if(!parent){
              console.error('Target did not have a parent, is it mounted in the DOM?');
          }
      }

      var cancel;

      while(parent){
          if(settings.debug){
              console.log('Scrolling parent node', parent);
          }

          if(validTarget(parent, parents) && (isScrollable ? isScrollable(parent, defaultIsScrollable) : defaultIsScrollable(parent))){
              parents++;
              cancel = transitionScrollTo(target, parent, settings, done);
          }

          parent = findParentElement(parent);

          if(!parent){
              done(COMPLETE);
              break;
          }
      }

      return cancel;
  };

  function scrollToElement(id, params) {
      var el = document.querySelector(id);
      if (!el) {
          console.error("\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0441 id \"" + id + "\" \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D");
          return;
      }
      var options = {
          align: {
              top: params ? params.top : 0,
              topOffset: params ? params.topOffset : 60,
          },
      };
      scrollIntoView(el, options);
  }

  function navLinkHandler(e, params) {
      e.preventDefault();
      var hash = e.currentTarget.hash;
      changeHash(hash);
      scrollToElement(hash, params);
  }
  function changeHash(hash) {
      if (window.history.pushState) {
          window.history.pushState(null, '', hash);
      }
      else {
          window.location.hash = hash;
      }
  }

  exports.breaksHundreds = breaksHundreds;
  exports.chunkify = chunkify;
  exports.emailValidate = emailValidate;
  exports.fetchJSON = fetchJSON;
  exports.fetchWithCache = fetchWithCache;
  exports.formatPublicDate = formatPublicDate;
  exports.getCurrentUrl = getCurrentUrl;
  exports.getHost = getHost;
  exports.getWordEnding = getWordEnding;
  exports.handingServerError = handingServerError;
  exports.isEmpty = isEmpty;
  exports.isNotEmpty = isNotEmpty;
  exports.navLinkHandler = navLinkHandler;
  exports.scrollToElement = scrollToElement;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map
